import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { FileService } from '@services/file.service';
import { NavLink } from '@classes/nav-link';
import { NavService } from '@services/nav.service';
import { FileConfig } from '@classes/file/file-config';
import { FileDetail } from '@classes/file/file-detail';
import { FileSource } from '@enums/file-source.enum';
import { UserService } from '@services/user.service';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-provider-files',
    templateUrl: './provider-files.component.html',
    styleUrls: ['./provider-files.component.scss']
})
export class ProviderFilesComponent implements OnInit, OnDestroy {
    private loadingSub: Subscription;

    years: FileConfig[];
    backLink: NavLink;
    isLoading: boolean;


    constructor(
        private fileSrv: FileService,
        private navSrv: NavService,
        private userSrv: UserService,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.backLink = this.navSrv.getLinkFromRoute(['simulation', 'live'], 'arrow_back');
    }

    onSelectFile(file: FileDetail, year: number): void {
        this.userSrv.setFileSource(file, FileSource.provider)
        .subscribe(() => {
            this.years.map(y => {
                if(y.year === year) {
                    y.selectedFileId = file.id;
                }
            });
        });
    }

    private initSubscriptions(): void {
        this.isLoading = true;
        this.fileSrv.getProviderFiles()
        .subscribe(fileYears => {
            this.years = fileYears;
            this.isLoading = false;
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
